import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { take, combineLatest, Observable, takeLast, map } from 'rxjs';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    this.authService.redirectionUrl = state.url;
    return this.authService.isAdmin.pipe(
      take(1),
      map((isAdmin: boolean) => {
        if (isAdmin) {
          return true;
        }
        
        if (this.authService.currentUser) {
          // Logged in but not an admin
          this.router.navigate(['/unauthorized']);
        } else {
          // Not logged in
          this.router.navigate(['/login']);
        }
        return false;
      })
    );
  }
}
